import { PatientSetPregnantCommand, VisitQuery } from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { FormContextValues } from '@dreryk/react-common';
import { ButtonVariant, dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { visitPatientPregnancyStatusTranslationKeys } from '../../translations';

import { PatientPregnancyMarkingFormBean } from './PatientPregnancyMarkingForm';

const t = visitPatientPregnancyStatusTranslationKeys;

type PatientPregnancyMarkingModalConfirmButtonProps = {
   readonly visitId: number;
   readonly handleSubmit: FormContextValues<PatientPregnancyMarkingFormBean>['handleSubmit'];
   readonly onSuccess: VoidFunction;
   readonly registerMedicalEvent: boolean;
};

export const PatientPregnancyMarkingModalConfirmButton = (
   props: PatientPregnancyMarkingModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: markPatientPregnancy } = useCqrsCommand<void, PatientPregnancyMarkingFormBean>(
      (parameters) => {
         const command = new PatientSetPregnantCommand();
         command.visitId = props.visitId;
         command.pregnancyConfirmed = parameters.pregnancyConfirmed;
         command.multiplePregnancy = parameters.multiplePregnancy;
         command.predictedCompletionDate = Choice.withUseDefaultIfNull(parameters.predictedCompletionDate ?? null);
         command.predictedCompletionBasis = Choice.withUseDefaultIfNull(
            parameters.predictedCompletionDateBasis ?? null
         );
         command.registerMedicalEvent = props.registerMedicalEvent;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               props.registerMedicalEvent
                  ? t.pregnancyMarkedSuccessfullyWithMedicalEvent
                  : t.pregnancyMarkedSuccessfully
            );
            refetchCqrsQuery(VisitQuery);
            props.onSuccess();
         },
      }
   );
   return (
      <ModalConfirmButton
         label={props.registerMedicalEvent ? t.markPatientPregnancyAndSendToP1 : t.markPatientPregnancy}
         onClick={props.handleSubmit(markPatientPregnancy)}
         variant={props.registerMedicalEvent ? ButtonVariant.SECONDARY : ButtonVariant.PRIMARY}
         testId={props.registerMedicalEvent ? 'markPatientPregnancyAndSendToP1' : 'markPatientPregnancy'}
      />
   );
};
